import SessionStore from '../stores/SessionStore.js'

function select(modifier) {
  if (SessionStore.isModifierSelected(modifier)) {
    SessionStore.unselectModifier(modifier);
  } else {
    SessionStore.selectModifier(modifier);
  }
}

function className(modifier) {
  if (SessionStore.isModifierSelected(modifier)) {
    return 'modifier modifier-selected';
  }
  return 'modifier';
}

function ModifierButton(props) {
  const {modifier} = props;

  let symbol = '';

  switch (modifier) {
    case 'flat':
      symbol = '♭';
      break;
    case 'sharp':
      symbol = '♯';
      break;
    default:
      symbol = '♮';
      break;
  }

  return (
    <button
      className={className(modifier)}
      onClick={() => {
        select(modifier);
      }}>
      {symbol}
    </button>
  );
}


export default ModifierButton;
